import { mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const marketResearch = {
  // 今日任务列表
  getTodayTaskList: data =>
    mallEntranceApi.post(apiPath.getTodayTaskList, data),
  // 任务明细
  getTaskDetail: data => mallEntranceApi.post(apiPath.getTaskDetail, data),
  // 上传ocr验证
  upOcr: data => mallEntranceApi.post(apiPath.upOcr, data),
  // 任务提交
  submitTask: data => mallEntranceApi.post(apiPath.submitTask, data),
  // 获取历史记录
  getRecord: data => mallEntranceApi.post(apiPath.getRecord, data),
  // 取消上传ocr
  deleteUpOcr: data => mallEntranceApi.post(apiPath.deleteUpOcr, data),
  // 获取优惠券信息，规则url
  getCouponInfo: data => mallEntranceApi.post(apiPath.getCouponInfo, data)
}
